export const showChar = (str: string) => {
  return str.replace(/&amp;/g, '&')
}
